import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import ArrowSvg from '../../../../assets/images/arrow-back.svg'
import Layout from '../../../components/Provider/Layout'
import CustomCard from '../../../components/shared/CustomCard'
import Loading from '../../../components/shared/Loading'
import MessageModal from '../../../components/shared/MessageModal'
import Search from '../../../components/shared/Search'
import useLocalStorage from '../../../hooks/useLocalStorage'
import ProviderServices from '../../../services/ProviderServices'
import { validateNumber } from '../../../utils/regexValidator'
// import dummyData from './data'
import './Query.scss'

// const data = [
//   {
//     oc: '0024128790',
//     dni: '48323666',
//     name: 'Laura Chávez',
//     guide: '5040368319',
//     details: [
//       {
//         id: '3600050000663779340001',
//         location: 'Bodega 2'
//       }
//     ]
//   },
//   {
//     oc: '3024128790',
//     dni: '23323232',
//     name: 'Luis Gonzales',
//     guide: '3040368319',
//     details: [
//       {
//         id: '0600050000663779340001',
//         location: 'Bodega 1'
//       },
//       {
//         id: '8600050000663779340001',
//         location: 'Bodega 4'
//       }
//     ]
//   },
//   {
//     oc: '4024128790',
//     dni: '65323212',
//     name: 'Federico Garcia',
//     guide: '2040362219',
//     details: [
//       {
//         id: '1600050000663779340001',
//         location: 'Bodega 5'
//       },
//       {
//         id: '2600050000663779340001',
//         location: 'Bodega 8'
//       }
//     ]
//   }
// ]

function Query() {
  const [textSearch, setTextSearch] = useState('')
  const [queryData, setQueryData] = useState([])
  const [loading, setLoading] = useState(false)
  const [ubicationError, setUbicationError] = useState(false)
  const [summaryData, setSummaryData] = useState(null)
  const [modalNoInternet, setModalNoInternet] = useState(false)
  const history = useHistory()
  const [userappret] = useLocalStorage('userappret')

  useEffect(() => {
    console.log(userappret)
    let timer = ''
    if (!userappret.pickupPointId) {
      setUbicationError(true)
      timer = setTimeout(() => {
        history.push('/home')
      }, 2500)
    }
    return () => timer ? clearTimeout(timer) : null
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true)
        const cudsAndSuborder = await ProviderServices.getCudsCount(userappret.pickupPointId)
        const cudsCount = cudsAndSuborder.cudCount
        const suborderCount = cudsAndSuborder.suborderCount
        // setQueryData(formatCuds(cuds))
        const ocs = await ProviderServices.getQueryOcs(userappret.pickupPointId)
        // setQueryData(formatData(ocs))
        const formattedData = await formatData(ocs)
        setQueryData(formattedData)
        // const cudsCount = {
        //   complete: 10
        // }
        setSummaryData({
          cudWithUbication: cudsCount.complete,
          suborderWithUbication: suborderCount.complete
        })
        setLoading(false)
      } catch (e) {
        console.log(e)
        setLoading(false)
        setModalNoInternet(true)
        setTimeout(() => {
          setModalNoInternet(false)
        }, 3000)
      }
    }
    fetchData()
    // eslint-disable-next-line
  }, [])

  const formatData = async ocs => {
    let data = []
    for (const oc of ocs) {
      oc.oc = oc.orderNumber
      oc.dni = oc.clientDni
      oc.name = oc.clientName
      oc.guide = oc.guideNumber
      data.push(oc)
    }
    return data
  }

  const handleTextChange = (e) => {
    const value = e.target.value
    if (validateNumber(value) && value.length < 10)
      setTextSearch(value)
  }

  const renderItems = () => {
    return queryData.map((d, i) => (!textSearch || d.dni.includes(parseInt(textSearch).toString())) ? (
      <CustomCard
        key={i}
        dni={d.dni}
        guide={d.guide}
        oc={d.oc}
        name={d.name}
        cuds={d.details}
        details={d.details}
        // date={moment(d.createdAt).subtract(5, 'hours').format('DD-MM-YY hh:mm A')}
        date={moment(d.updatedAt).subtract(5, 'hours').format('DD-MM-YY hh:mm A')}
        // date={moment(d.receptionDate).format('DD-MM-YY')}
      />
    ) : null)
  }

  const UbicationSummary = ({ summaryData }) => summaryData ? (
    <div className='query-summary'>
      {getLabel(summaryData.cudWithUbication, summaryData.suborderWithUbication)}
    </div>
  ) : null

  const getLabel = (cudNumber, suborderNumber) => {
    let string = ''
    cudNumber > 1 ? string += 's' : string += ''
    let string2 = ''
    suborderNumber > 1 ? string2 += 's' : string2 += ''
    return `${cudNumber} CUD${string} y ${suborderNumber} sub-pedido${string2} ubicados`
  }

  return (
    <Layout>
      <Loading visible={loading} />
      <MessageModal visible={modalNoInternet} closeModal={() => setModalNoInternet(false)} message='No tiene conexión a internet. Conéctese y refresque la pantalla' type={2} />
      <MessageModal
        visible={ubicationError}
        message='No tiene una ubicación asignada, elija una o pida que se le asigne una'
        type={1}
      />
      <div className='query-container'>
        <div className='query-header'>

          <Link to={userappret.roleName === 'carrier' ? {
            pathname: '/home',
            state: {
              plate: userappret.plate,
              operator: userappret.operator,
              from: 'consulta'
            }
          } : '/home'} style={{ display: 'flex' }}><img src={ArrowSvg} alt='atras' /></Link>
          <h3>Consulta de pedidos</h3>
        </div>
        <div className='query-search-container'>
          <Search
            text={textSearch}
            setText={handleTextChange}
            placeholder={'Buscar por DNI'}
          />
        </div>
        <UbicationSummary summaryData={summaryData} />
        <div className='query-items-container'>
          {renderItems()}
        </div>
      </div>
    </Layout>
  )
}

export default Query
